module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8e6e65fc01177b14d8bc730e91adfad6.png";